import React from 'react'
import PropTypes from 'prop-types'

class ShowHide extends React.Component {
   render() {
     const { show, style = {} } = this.props
     return (
      <div style={{ ...style, display: show ? (style.display ? style.display : 'block') : 'none' }}>
        {this.props.children}
      </div>
     )
   }
 }
 
 ShowHide.propTypes = {
   show: PropTypes.bool.isRequired,
   children: PropTypes.node,
   style: PropTypes.object,
 }
 
 export default ShowHide


// WEBPACK FOOTER //
// ./src/components/ShowHide2/index.js